import { ScreenViewContract } from '@headspace/hs-events/generated/types/contracts/screenview';

export const createScreenViewContract = (
  screenView?: Partial<ScreenViewContract>,
): ScreenViewContract => ({
  ...screenView,
});
